import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.scss';
import LanguageTest from './Components/Language-Test/languageTest';
import Complete from './Components/Language-Test/complete';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/language-test/12345" replace />} />
        <Route path="/language-test/:token" element={<LanguageTest />} />
        <Route path='/exam/:token/complete' element={<Complete />} />
      </Routes>
    </Router>
  );
}

export default App;
